
module.exports = {


    // 个人学习系统班
    personalLearnClass: {
        title: 'Personal Learning System Class',
        info1: "Focusing on the enhancement of enterprise strategy and the upgrading of leadership, in hopes of systematically improving the managerial ability of enterprise leaders and managers, we provide three major long-term systematic courses, namely, the President Program, the Excellence Program and the Capital Program, for business leaders and managers who wish—with supporting, real-world-modeled tools and effective solutions— to systematically enhance their management capabilities, and facilitate students' long-term and stable entrepreneurial development.",
        info2: '',
        info3: '',
        projectList: {
            item1: {
                projectText: {
                    title: 'CEO Program',
                    info: 'Enterprise CEOs who want to achieve personal improvement',
                },
                projectInfo: {
                    title1: 'can quickly improve their self-awareness and promote the steady and long-term development of the enterprise.',
                    title2: '',
                }
            },
            item2: {
                projectText: {
                    title: 'Elite Program',
                    info: 'Enterprise executives who want to become the left and right hands of the CEO',
                },
                projectInfo: {
                    title1: 'from business experts to management experts, ',
                    title2: 'from personal success to team success.',
                }
            },
            item3: {
                projectText: {
                    title: 'Capital Program',
                    info: 'CEOs with planning for the development of corporate capital',
                },
                projectInfo: {
                    title1: 'enhance their practical capital operation capabilities, ',
                    title2: 'effectively linking capital and peer resources.',
                }
            },
        },
        table: {
            header: {
                head1: 'Short program title',
                head2: 'President Program',
                head3: 'Excellence Program',
                head4: 'Capital Program',
            },
            data: [
                {
                    head1: 'Full program title',
                    head2: 'BOSUM President Program',
                    head3: 'Business Talent Action Breakthrough Training Camp',
                    head4: 'Practical Program in Private Enterprise Capital Operation',
                },
                {
                    head1: 'Appropriate targets',
                    head2: 'Enterprise founders',
                    head3: 'Enterprise executives',
                    head4: 'Enterprise founders',
                },
                {
                    head1: 'Encountered stresses',
                    head2: ['1.Enterprise growth difficulties ', '2.  Weak operation and management ', '3. Lack of effective resources'],
                    head3: ['1.  Lack of sense of accomplishment in personal work ', '2. Disorganized team and difficult collaboration ', '3. Organizational performance cannot be achieved'],
                    head4: ['1. There are blind spots in capital operation', '2. Lack of financing channels ', "3. The company's finances and taxes are not standardized", '4. The top-level structure is irrational'],
                },
                {
                    head1: 'Course objectives',
                    head2: ['Improve the three core competencies of the president', '—strategy, operations, leadership'],
                    head3: ['1. Become the left and right hand of the boss', '2. Motivate the team and operate efficiently', '3. Achieve process management'],
                    head4: ["1. Cultivate capital operation ability", "2. Build a resource docking platform", "3. Strengthen corporate governance", "4. Transform and upgrade capital operation"],
                },
                {
                    head1: 'Program modules',
                    head2: ['《Seven-Step Strategy—Inspire Sustained Growth 》', '《Business Model Innovation—Finding New Profit Areas 》', '《Operational Control—Driving Strategy Execution 》', '《Big Financial Thinking—Management by Data for Cost 》', '《Reductions and Efficiency Increases Sales Management Codes—Creating Sales Champions》', '《Talent Strategy—Supporting Enterprise Performance Breakthroughs》', '《Win-Win Leadership—Enabling Organizations and Teams to win Together》'],
                    head3: ['1. Self-achievement. ', '《Role Orientation and Cognition of Managers》', '《Public Speaking and Effective Communication》', '2.Winning Results', '《Strategy Execution and Control of Objectives》', '《Financial Thinking for Decision Makers》', '《Organizational Performance Improvement Workshop》', '3. Building Teams', '《Selection and Employment: Team Building and Talent Selection》', '《Talent Training and Compensation Motivation》', '《Employee Counseling and Motivation》'],
                    head4: ["1. Capital thinking", "《The Entrepreneur‘s Capital Thinking and Investment and Financing Strategy》", "《Capital Games and Class Team Building Training Camp》", "2. Business design", "《The Underlying Logic and Model Innovation of Enterprises 》", "3. Standardized governance", "《Financial Analysis and Business Value》", "《Corporate Governance and Top-Level Design》", "《Enterprise Equity Design and Incentives》", "4. Industry-finance linkage", "《Innovative Financing Strategies》", "《Business Valuation; Private Equity Investment》", "《Multi-level Capital Market and Enterprise Capital Operation Paths》", "《Enterprise Mergers and Acquisitions》",],
                },
                {
                    head1: 'Study system',
                    head2: 'Fifteen months',
                    head3: 'Ten months',
                    head4: 'One year',
                },
                {
                    head1: 'Region',
                    head2: 'Nationwide',
                    head3: 'Nationwide',
                    head4: 'Nationwide',
                },
                {
                    head1: 'Fee',
                    head2: '99,000',
                    head3: '42,800',
                    head4: '99,000',
                },
                {
                    head1: 'Download leaflet',
                    head2: 'Tap to Download',
                    head3: 'Tap to Download',
                    head4: 'Tap to Download',
                },
            ]
        }
    },
    // 陪跑系列
    accompanyRunSeries: {
        title: 'Program categories',
        info1: 'Projects that accompany students at length on the ground are suitable for team organizations that lack execution conditions and need coaches to accompany them, including guidance and customized internal training on strategy, organization, finance, human resources, etc., combining theory with practice to help companies achieve results, surpass growth bottlenecks and avoid detours.',
        projectList: {
            item1: {
                projectText: {
                    title: 'Strategic coaching project',
                    info: 'run a corporate team that faces human, financial, and material troubles',
                },
                projectInfo: {
                    title1: 'Achieve a closed loop from strategy to execution,',
                    title2: 'and build a winning team',
                }
            },
            item2: {
                projectText: {
                    title: 'Fire up the organization for 90 days',
                    info: 'the enterprise team that needs to solve a certain business problem at a single point',
                },
                projectInfo: {
                    title1: 'Exceeds its objectives and gets results, ',
                    title2: 'stoking the rapid growth of the organization',
                }
            },
            item3: {
                projectText: {
                    title: 'BOSUM·Lighthouse Project',
                    info: 'founders who cannot achieve further breakthroughs in management',
                },
                projectInfo: {
                    title1: 'Learn from more accomplished people ',
                    title2: 'and become pioneers in the industry',
                }
            },
        },
        table: {
            header: {
                head1: 'Program categories',
                head2: 'Strategic coaching companion program',
                head3: 'Fire up the organization for 90 days',
                head4: 'BOSUM·Lighthouse Project',
            },
            data: [
                {
                    head1: 'Applicable targets',
                    head2: 'Founders, executives, etc.',
                    head3: 'Founders, executives, etc.',
                    head4: 'Founders',
                },
                {
                    head1: 'Encountered stresses',
                    head2: 'Human, financial and material issues in the course of business operations',
                    head3: ['1. Lax organization', '2. Goals are difficult to achieve'],
                    head4: ["1. Stuck in a growth bottleneck", "2. Management problems are deep - seated", "3. Increasingly complex operations", "4. Employee ability is substandard",],
                },
                {
                    head1: 'Course objectives',
                    head2: ["Completing the closed loop, from strategy to execution to realization:", "1. A result surpassing objectives", "2. An executable tracking mechanism", "3. A set of effective team motivation tools", "4. A winning team culture",],
                    head3: ["1. Reasonably set core business goals", "2. Design incentives", "3. The surpassing of objectives and securing of results",],
                    head4: ["1. Learning from real - world experience and reducing pitfalls", "2. Resolution of problems of business growth breakthroughs", "3. Links to enterprise industry resources",],
                },
                {
                    head1: 'Course modules',
                    head2: '《Strategic Coach Companion Program》',
                    head3: '《Igniting Organizational Strength in 90 days》',
                    head4: ['《BOSUM·Lighthouse Project Bo Lianming—Enterprise Breakthroughs》', '《BOSUM·Lighthouse Project Wei Zhe—Growing and Breaking the Circle》'],
                },
                {
                    head1: 'Study system',
                    head2: 'Six months',
                    head3: 'Three months',
                    head4: 'Six months',
                },
                {
                    head1: 'Region',
                    head2: 'Nationwide',
                    head3: 'Nationwide',
                    head4: 'Shenzhen/Shanghai',
                },
                {
                    head1: 'Fee',
                    head2: '79,800',
                    head3: '49,800',
                    head4: '19,800',
                },
                {
                    head1: 'Download leaflet',
                    head2: 'Tap to Download',
                    head3: 'Tap to Download',
                    head4: 'Tap to Download',
                },
            ]
        },
        projectList2: {
            item1: {
                projectText: {
                    title: 'Accompanied by finance',
                    info: 'it is necessary to build a financial system to promote enterprise teams with which business and finance are integrated',
                },
                projectInfo: {
                    title1: 'Use financial data to support the',
                    title2: 'business development of the enterprise',
                }
            },
            item2: {
                projectText: {
                    title: 'Accompanied by sales',
                    info: 'the corporate team whose performance growth has encountered a bottleneck',
                },
                projectInfo: {
                    title1: 'Surpasses that bottleneck and continues ',
                    title2: 'to improve performance over the long term',
                }
            },
            item3: {
                projectText: {
                    title: 'Running with human resources',
                    info: 'enterprise teams facing difficulties in recruitment, education and employment',
                },
                projectInfo: {
                    title1: 'Effectively activate the strengths of their talents ',
                    title2: 'and comprehensively improve organizational capabilities',
                }
            },
            item4: {
                projectText: {
                    title: 'Customized corporate internal training',
                    info: "enterprise teams that need to improve the company's overall management standard and employees' professional capabilities",
                },
                projectInfo: {
                    title1: "Improve the company's management ",
                    title2: 'standard and employee quality',
                }
            },
        },
        table2: {
            header: {
                head1: 'Program categories',
                head2: 'Finance companion',
                head3: 'Sales companion',
                head4: 'Human resources companion',
                head5: 'Customized corporate internal training',
            },
            data: [
                {
                    head1: 'Applicable targets',
                    head2: 'Founders, finance teams',
                    head3: 'Bosses + sales teams',
                    head4: 'Bosses + HR leaders + core executives',
                    head5: 'Core corporate teams',
                },
                {
                    head1: 'Encountered stresses',
                    head2: ["1. Employees’ and bosses’ views diverge", "2. There are risks in the financial system", "3. Enterprise growth is limited",],
                    head3: ["1. Lack of sales processes", "2. Sales management is chaotic", "3. It is difficult to train sales talents",],
                    head4: ["1. It is difficult to recruit talents, and posts are incompatible", "2. Talent growth is slow", "3. Low human efficiency affects output",],
                    head5: ["1. The choice of external institutions and teachers is only partially plausible", "2. Course experience and training effects are uncontrollable", "3. It is difficult to formulate effective personnel training plans",],
                },
                {
                    head1: 'Course objectives',
                    head2: ["1. Achievement of the same frequency resonance as the team", "2. Establishment of a financial management system to control risks", "3. Continuance of profit generation",],
                    head3: ["1. Reaping of the rewards of exclusive sales processes", "2. Acquisition of effective sales tools", "3. Building of a gold medal sales team",],
                    head4: ["1. Activation of talent strengths", "2. Establishment of a talent training and incentive system", "3. Improvement of organizational capabilities",],
                    head5: ["1. Analysis and evaluation of the status quo of the enterprise and personnel", "2. Delivery of help to students and organizations to grow in an all - round way",],
                },
                {
                    head1: 'Course modules',
                    head2: ['《Post-President Financial Control System;》', '《Business and Wealth Integration Companion Project》'],
                    head3: '《Sales Success Companion Project》',
                    head4: '《Companion Project on Raising Organizational Capability》',
                    head5: ['《Management Companionship》', '《Team Companionship》', '《Specialist Improvement Series》', '《All-Staff Quality Improvement Series》'],
                },
                {
                    head1: 'Study system',
                    head2: 'Three to six months',
                    head3: 'Three to twelve months',
                    head4: 'Three months',
                    head5: 'Details',
                },
                {
                    head1: 'Region',
                    head2: 'Nationwide',
                    head3: 'Nationwide',
                    head4: 'Nationwide',
                    head5: 'Nationwide',
                },
                {
                    head1: 'Fee',
                    head2: 'Details',
                    head3: 'Details',
                    head4: 'Details',
                    head5: 'Details',
                },
                {
                    head1: 'Download leaflet',
                    head2: 'Tap to Download',
                    head3: 'Tap to Download',
                    head4: 'Tap to Download',
                    head5: 'Tap to Download',
                },
            ]
        }
    },
    // 领跑系列
    lead: {
        title: 'Leading Series',
        info1: 'The leading Series covers in-depth consulting on business management and in-depth consulting in the field of self-media. ',
        info2: 'In-depth consulting on business management: suitable for companies that have reached a certain scale and hope to achieve greater breakthroughs and comprehensive self-upgrades, including operational efficiency, organizational capabilities, sales management, financial compliance, and annual financial and tax consulting, enabling companies to continue to enjoy self-restoration capabilities, establish "moats" and become leaders in their industries.',
        info3: 'In-depth consultation in the self-media field: suitable for corporate CEOs, decision makers, and project leaders who want to achieve breakthroughs in such new media fields as new media, short videos, and live broadcasts. Through such services as content positioning, pop-up video templates, and team building, such consultation can solve the problem of corporate entry into live-streaming and the whole-link problem with short videos, achieving transformation and leadership.',
        info4: "In-depth consulting on business management",
        info5: "In-depth consulting in the field of self-media",
        projectList: {
            item1: {
                projectText: {
                    title: 'Operating Efficiency Upgrades',
                    info: 'Enterprises that want to achieve closed-loop operation by establishing a system',
                },
                projectInfo: {
                    title1: 'Improve internal efficiency and ',
                    title2: 'help enterprises continue to grow',
                }
            },
            item2: {
                projectText: {
                    title: 'Organizational Capability Improvement',
                    info: 'Enterprises that want to achieve business goals by establishing a scientific organizational development model',
                },
                projectInfo: {
                    title1: 'Empower teams to help improve organizational efficiency',
                    title2: '',
                }
            },
            item3: {
                projectText: {
                    title: 'Sales Management Building',
                    info: 'Enterprises that want to standardize the sales system and build an enterprise with a strong sales force',
                },
                projectInfo: {
                    title1: 'Create a sales management system',
                    title2: 'that continues to win orders',
                }
            },
        },
        table: {
            header: {
                head1: 'Program categories',
                head2: 'Operational efficiency upgrade consulting',
                head3: 'Organizational capability enhancement consulting',
                head4: 'Sales management creation consulting',
            },
            data: [
                {
                    head1: 'Applicable targets',
                    head2: 'Corporate teams',
                    head3: 'Corporate teams',
                    head4: 'Corporate teams',
                },
                {
                    head1: 'Stress points encountered',
                    head2: ["1. Actual managerial effect: no one available", "2. Prominent bottlenecks and incentive decoupling", "3. Unclear responsibilities and goals",],
                    head3: ["1. Inconsistencies in the thinking and opinions of middle and senior leaders lead to internal friction ", "2. Employee efficiency is low, bosses and employees are busy every day, and performance is not visible ", "3. Managers and employees lack sense of responsibility and blame each other ", "4. Managers are unwilling to train subordinates and lack talents",],
                    head4: ["1. Sales projects cannot be promoted ", "2. Difficulty negotiating sales orders ", "3. There is no suitable sales tool",],
                },
                {
                    head1: 'Project objectives',
                    head2: ["1. Establish systems", "2. Strengthen organizations", "3. Smash bottle - necks",],
                    head3: ["1. Plan business blueprint", "2. Achieve top - to - bottom coordination", "3. Strengthen organizational systems",],
                    head4: ["1. Build a sales force", "2. Establish a performance transaction system", "3. Achieve 1 - 2 core order breakthroughs",],
                },
                {
                    head1: 'Project content',
                    head2: ["1. Building operational management and control systems", "2. Strengthening organizational and operational capabilities", "3. Breaking core business bottlenecks",],
                    head3: ["1. Activating organizational performance", "2. Firing up talent motivation", "3. Upgrading talent capabilities",],
                    head4: ["1. Planning the overall situation and organizing the work force", '2. Creating a "wolf-like" sales force', "3. Breaking transaction bottlenecks and promoting performance improvement",],
                },
                {
                    head1: 'Study system',
                    head2: 'Six months',
                    head3: 'Six months',
                    head4: 'Six months',
                },
                {
                    head1: 'Region',
                    head2: 'Nationwide',
                    head3: 'Nationwide',
                    head4: 'Nationwide',
                },
                {
                    head1: 'Fee',
                    head2: 'Quotation in accordance with the specific situation of the enterprise',
                    head3: 'Quotation in accordance with the specific situation of the enterprise',
                    head4: 'Quotation in accordance with the specific situation of the enterprise',
                },
                {
                    head1: 'Download leaflet',
                    head2: 'Tap to Download',
                    head3: 'Tap to Download',
                    head4: 'Tap to Download',
                },
            ]
        },
        projectList2: {
            item1: {
                projectText: {
                    title: 'Financial Compliance Consulting',
                    info: 'Enterprises that want to reduce costs and increase efficiency, achieve corporate compliance, and become bigger and stronger',
                },
                projectInfo: {
                    title1: 'Make consulting more practical and ',
                    title2: 'finance and taxation more compliant',
                }
            },
            item2: {
                projectText: {
                    title: '销售陪跑',
                    info: '业绩增长遭遇瓶颈的企业团队',
                },
                projectInfo: {
                    title1: '打破企业销售瓶颈',
                    title2: '长期持续提高业绩',
                }
            },
            item3: {
                projectText: {
                    title: '人力陪跑',
                    info: '面临招人难、育人难、用人难的企业团队',
                },
                projectInfo: {
                    title1: '有效激活人才优势',
                    title2: '全面提升组织能力',
                }
            },
            item4: {
                projectText: {
                    title: '定制化企业内训',
                    info: '需提高公司整体管理水平、员工专业能力的企业团队',
                },
                projectInfo: {
                    title1: '提升公司的经营管理水平',
                    title2: '及员工素质',
                }
            },
        },
        projectList4: {
            item1: {
                projectText: {
                    title: 'In-depth consulting in the field of selfmedia',
                    info: 'Enterprise teams that want to enter the field of short video and live streaming',
                },
                projectInfo: {
                    title1: 'Seize the opportunity presented by the short video and ',
                    title2: 'live streaming craze and build new online marketing scenes',
                }
            },
            item2: {
                projectText: {
                    title: '销售陪跑',
                    info: '业绩增长遭遇瓶颈的企业团队',
                },
                projectInfo: {
                    title1: '打破企业销售瓶颈',
                    title2: '长期持续提高业绩',
                }
            },
            item3: {
                projectText: {
                    title: '人力陪跑',
                    info: '面临招人难、育人难、用人难的企业团队',
                },
                projectInfo: {
                    title1: '有效激活人才优势',
                    title2: '全面提升组织能力',
                }
            },
            item4: {
                projectText: {
                    title: '定制化企业内训',
                    info: '需提高公司整体管理水平、员工专业能力的企业团队',
                },
                projectInfo: {
                    title1: '提升公司的经营管理水平',
                    title2: '及员工素质',
                }
            },
        },
        table2: {
            header: {
                head1: 'Program categories',
                head2: 'Accounting compliance consulting',
                head3: 'Annual financial and tax consultation',
            },
            data: [
                {
                    head1: 'Applicable targets',
                    head2: 'Corporate teams',
                    head3: 'Corporate teams',
                },
                {
                    head1: 'Stress points encountered',
                    head2: ["1. There are risks in non - standard finance and taxation", "2. High costs and low profits",],
                    head3: ["1. Financial statements are unable to support project decisions", "2. Lack of timely understanding of the latest tax laws and policies", "3. The professionalism of financial personnel needs to be improved",],
                },
                {
                    head1: 'Project objectives',
                    head2: ["1. Enterprise risk visualization", "2. Policy basis for compliance rectification ", "3. Compliance optimization of corporate tax structure", "4. Controllability of report form self - examination risks", "5. Resolution of cost bill compliance and capital compliance", "6. Reduction of corporate costs and increase in corporate profits",],
                    head3: ["1. Perspective on enterprise risk", "2. Financial team building, business and financial integration", "3. Fund compliance and reasonable allocation", "4. Every decision backed by data", "5. Financial personnel trained in line with the enterprise", "6. Legal tax saving to ensure the safety of the company's wealth ", "7. Accurate budgets, cost reductions and efficiency increases", "8. Safe inheritance of family wealth, value preservation and appreciation",],
                },
                {
                    head1: 'Project content',
                    head2: ["1. Corporate health reports", "2. Resolution of historical problems", "3. Top - level structure design", "4. Corporate tax planning", "5. Tax statement review",],
                    head3: ["1. Establishing a financial support system","2. Establishing a management report system","3. Establishing an accounting system","4. Establishing a fund management and control system","5. Establishing a financial analysis system","6. Building a financial management system","7. Establishing a tax management system","8. Building finance team competencies",],
                },
                {
                    head1: 'Study system',
                    head2: 'Six months',
                    head3: 'Twelve months',
                },
                {
                    head1: 'Region',
                    head2: 'Nationwide',
                    head3: 'Nationwide',
                },
                {
                    head1: 'Fee',
                    head2: 'CNY 69,980',
                    head3: 'CNY 1,000,000',
                },
                {
                    head1: 'Download leaflet',
                    head2: 'Tap to Download',
                    head3: 'Tap to Download',
                },
            ]
        },
        projectList3: {
            item1: {
                projectText: {
                    title: '战略教练陪跑项目',
                    info: '经营面临人、财、物困扰的企业团队',
                },
                projectInfo: {
                    title1: '实现从战略到执行的闭环',
                    title2: '打造一个能打胜仗的团队',
                }
            },
            item2: {
                projectText: {
                    title: '引爆组织90天',
                    info: '需要单点解决某个经营问题的企业团队',
                },
                projectInfo: {
                    title1: '突破目标拿到结果',
                    title2: '引爆组织快速增长',
                }
            },
            item3: {
                projectText: {
                    title: '博商·灯塔计划',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectInfo: {
                    title1: '跟更有结果的人学习',
                    title2: '成为行业的先锋',
                }
            },
        },
        table3: {
            header: {
                head1: 'Program categories',
                head2: 'Establish US short video marketing consulting leadership',
                head3: 'Establish US live streaming marketing consulting leadership',
                head4: 'Establish US short video and live streaming marketing consulting leadership&直播营销咨询领跑',
            },
            data: [
                {
                    head1: 'Applicable targets',
                    head2: 'Corporate CEOs, project leaders',
                    head3: 'Corporate CEOs, project leaders',
                    head4: 'Corporate CEOs, project leaders',
                },
                {
                    head1: 'Encountered stresses',
                    head2: ["1. Don’t understand short video marketing methods","2. Content positioning is not clear","3. Don’t understand the broadcasting logic",],
                    head3: ["1. Don't know how to start a live stream ","2. Lack of traffic and conversion skills","3. The anchor team is not professional enough",],
                    head4: ["1. Difficulty in entering short videos","2. Difficulty in entering live streaming",],
                },
                {
                    head1: 'Course objectives',
                    head2: ["1. Position short video accounts clearly","2. Find content differences","3. Achieve traffic monetization",],
                    head3: ["1. Select the live streaming mode that suits the enterprise","2. Improve the flow and conversion of the live streaming room","3. Build a professional anchor team",],
                    head4: ["1. Select the right platform","2. Position clearly","3. Achieve traffic",],
                },
                // {
                //   head1: 'Project content',
                //   head2: ['1. 建运营管控系统', '2. 强组织运营能力', '3. 破核心经营瓶颈'],
                //   head3: ['1. 激活组织绩效', '2. 点燃人才动力', '3. 升级人才能力'],
                //   head4: ['1. 谋定全局、排兵布阵', '2. 打造“狼性”销售铁军', '3. 破成交瓶颈，促业绩提升'],
                // },
                {
                    head1: 'Study system',
                    head2: 'Three months',
                    head3: 'Three months',
                    head4: 'Three months',
                },
                {
                    head1: 'Region',
                    head2: 'Nationwide',
                    head3: 'Nationwide',
                    head4: 'Nationwide',
                },
                {
                    head1: 'Fee',
                    head2: '29.8万',
                    head3: '29.8万',
                    head4: '49.8万',
                },
                {
                    head1: 'Download leaflet',
                    head2: 'Tap to Download',
                    head3: 'Tap to Download',
                    head4: 'Tap to Download',
                },
            ]
        },

    },
    onLine: {
        title: 'Online series',
        info1: 'Bosum Wheat online learning classroom is suitable for entrepreneurs or managers whose time is fragmented but who want to learn anytime, anyplace. It brings together 180+ high-quality Boshang course videos, including business models, equity design, financial and tax management, profit growth, and sales management etc—10 management methodologies that have been proven in practice—so that students can improve their management cognition, master the methods and implement them.',
        info2:"Learn anytime, ",
        info3:"anyplace.",
        info4:"Courses that ",
        info5:"have been tested",
        info6:"in real life can be used after learning",
        info7:"To know more about the courses <br> Please access the Bosum Xiao Mai APP",
        projectList: {
            item1: {
                projectText: {
                    title: 'Bosum Xiao Mai',
                    info: 'Entrepreneurs and career elites who can learn only in fragments',
                },
                projectInfo: {
                    title1: '100+ practical mentors guide the way, ',
                    title2: 'and management does',
                }
            },
      
        },
    },
    // 团队共学研习社
    teamLearnTrainSociety: {
        title: 'Team Co-learning Research Society',
        info1: 'Short-term intensive training courses focusing on markets, efficiency, resources, and model breakthroughs, through team learning, help team organizations that want to improve their capabilities in certain vertical fields, strengthen practical capabilities and team core competitiveness, and promote overall company development.',
        projectList: {
            item1: {
                projectInfo: {
                    title: 'Market breakthroughs',
                    info: '',
                },
                projectText: [
                    {
                        title: 'Marketing systems',
                        text: 'deciphering the marketing methodology for creating category champions'
                    },
                    {
                        title: 'New media marketing',
                        text: 'unlocking new media marketing methods, opening up the short video live streaming public to private promotion to promote repurchases, and strengthen traffic acquisition capabilities'
                    },
                    {
                        title: 'Sales management',
                        text: 'improve the win rate of major customers and the sales team‘s mastery of performance'
                    },
                ]
            },
            item2: {
                projectInfo: {
                    title: 'Efficiency breakthroughs',
                    info: '',
                },
                projectText: [
                    {
                        title: 'Organizing talents',
                        text: '•building the cornerstone of organizational evolution, activating the talent management system, and stimulating the potential of organizational synergy'
                    },
                    {
                        title: 'Operational management and control：',
                        text: 'building operational management and control systems, and using management and control mechanisms and process mechanisms to replace dependence on humans.'
                    },
                ]
            },
            item3: {
                projectInfo: {
                    title: 'Resource breakthroughs',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectText: [
                    {
                        title: 'Controling finance and tax',
                        text: 'preventing tax risks, legally saving taxes, improving capital turnover efficiency, and creating the value of financial and tax supporting business resources'
                    },
                    {
                        title: 'Equity design',
                        text: 'avoiding equity structure risk, rationally designing incentives to achieve the coalescence of dispersed wealth and people, and upgrade enterprise resources'
                    },
                    {
                        title: 'Capital financing',
                        text: 'surmounting the difficulties of enterprise investment and financing, harvesting external resources, and accelerating enterprise growth'
                    },
                ]
            },
            item4: {
                projectInfo: {
                    title: 'Model breakthroughs',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectText: [
                    {
                        title: 'Business model：',
                        text: 'sorting out and diagnosing business models, focusing on profitability and finding breakthroughs'
                    },
                    {
                        title: 'Strategy',
                        text: 'finding breakthroughs based on the industrial value chain and mining for core competitive advantages'
                    },
                ]
            },
        },
        table: {
            header0: {
                head1: 'Program categories',
                head2: 'Market breakthroughs',
            },
            header: {
                head1: 'Modules',
                head2: 'Marketing systems',
                head3: 'New media marketing',
                head4: 'Marketing management',
            },
            data: [
                {
                    head1: 'Appropriate targets',
                    head2: 'Founding partners + heads of branding/marketing',
                    head3: 'Founding partners + new media business players',
                    head4: 'Founding partners + sales directors and backbones',
                },
                {
                    head1: 'Encountered stresses',
                    head2: ["1.Lack of comprehensive marketing awareness", "2.Fragmented brand planning and frenetic product creation"],
                    head3: ["1.Little knowledge of new media", "2.Will not open up traffic realization and transformation", "3.The cost of acquiring customers is high, so we can only fight price wars",],
                    head4: ['1.The boss lacks a sense of control over the performance management of the business team', '2.The sales team has no fight'],
                },
                {
                    head1: 'Course objectives',
                    head2: ["1.Master systematic marketing methods", "2. Explore popular products, strengthen brands,and achieve product premiums",],
                    head3: ['1.Decrypt traffic and enjoy short video live streams', '2.Open up the private domain to promote retention and repurchase'],
                    head4: ["1. Integrate the instructor's practical experience, transforming it into a sales management style suitable for small and medium-sized enterprises", "2. Improve the win rate of major customers and the sales team‘s mastery of performance."],
                },
                {
                    head1: 'Newest courses',
                    head2: '《Winning in F8 marketing systems》',
                    head3: ['《Winning in Vlogs》', '《Winning in live streaming》', '《Winning in the private domain》', '《Winning in local life》'],
                    head4: '《Winning in sales》',
                },
                {
                    head1: 'Study system',
                    head2: '2–3 days (depending on the specific course)',
                    head3: '2–3 days (depending on the specific course)',
                    head4: '2–3 days (depending on the specific course)',
                },
                {
                    head1: 'Proposed number of attendees',
                    head2: 'At least two',
                    head3: 'At least two',
                    head4: 'At least two',
                },
                {
                    head1: 'Region',
                    head2: 'Nationwide',
                    head3: 'Nationwide',
                    head4: 'Nationwide',
                },
                {
                    head1: 'Fee',
                    head2: 'Different fees for each specific course. See leaflet for details.',
                    head3: 'Different fees for each specific course. See leaflet for details.',
                    head4: 'Different fees for each specific course. See leaflet for details.',
                },
                {
                    head1: 'Download leaflet',
                    head2: 'Tap to Download',
                    head3: 'Tap to Download',
                    head4: 'Tap to Download',
                },
            ]
        },
        table2: {
            header0: {
                head1: 'Program categories',
                head2: 'Efficiency breakthroughs',
            },
            header: {
                head1: 'Modules',
                head2: 'Organizational talent',
                head3: 'Operational control',
            },
            data: [
                {
                    head1: 'Appropriate targets',
                    head2: 'Founding partners + manpower directors and other executives',
                    head3: 'Founding partners + professional managers (backbones of the executive/middlelevels )',
                },
                {
                    head1: 'Appropriate targets',
                    head2: ["1. It is difficult to promote organizational reform", "2. It is difficult to select and retain talent", "3. Lack of cohesion and self-motivation within the organization",],
                    head3: ["1. The efficiency of various aspects, such as organizational operation/production/delivery is declining and development is delayed", "2. The enterprise does not have a clear business goal, and it is difficult to achieve goals",],
                },
                {
                    head1: 'Course objectives',
                    head2: ["1. Solve difficult problems, such as talent training and recruitment", "2. Effectively build and implement corporate culture", "3. Design an incentive mechanism to stimulate teamwork",],
                    head3: ['Cultivate talents who use mechanism and process management to create a closed loop of enterprise operation management systems'],
                },
                {
                    head1: 'Newest courses',
                    head2: ['《Winning in talent》 (exclusivity)', '《Winning in organizational evolution》', '《Winning in achievements》', '《Team wins 》(exclusivity)'],
                    head3: ['《Winning in process: replicating success with process》', '《Winning in operations 》', '《Firing up organization capability》'],
                },
                {
                    head1: 'Proposed number of attendees',
                    head2: '2–3 days (depending on the specific course)）',
                    head3: '2–3 days (depending on the specific course)）',
                },
                {
                    head1: 'Proposed number of attendees',
                    head2: 'At least two',
                    head3: 'At least two',
                },
                {
                    head1: 'Region',
                    head2: 'Nationwide',
                    head3: 'Nationwide',
                },
                {
                    head1: 'Fee',
                    head2: 'Different fees for each specific course. See leaflet for details.',
                    head3: 'Different fees for each specific course. See leaflet for details.',
                },
                {
                    head1: 'Download leaflet',
                    head2: 'Tap to Download',
                    head3: 'Tap to Download',
                },
            ]
        },
        table3: {
            header0: {
                head1: 'Program categories',
                head2: 'Resource breakthroughs',
            },
            header: {
                head1: 'Modules',
                head2: 'Financial and tax control',
                head3: 'Equity design',
                head4: 'Capital financing',
            },
            data: [
                {
                    head1: 'Appropriate targets',
                    head2: 'Founders + chief financial officers and other decision-making levels',
                    head3: 'Corporate CEOs, general managers and other decision-making levels',
                    head4: 'Founding partners + other decision-making levels',
                },
                {
                    head1: 'Encountered stresses',
                    head2: ["1. Cash flow pressure", "2. The shareholding structure is irrational", "3. Tax policy is not understood and there are overpayments and non-payments", "4. High cost and low profit",],
                    head3: ["1. Equity design is vague and nepotism is practiced", "2. The enterprise structure is not standardized and there are risks", "3. Low employee enthusiasm affects efficiency", "4. Equity changes affect corporate listings",],
                    head4: ['1. Interested in investment and financing, but ignorant of such matters', '2.Financing repeatedly hits walls'],
                },
                {
                    head1: 'Course objectives',
                    head2: ["1.Improve capital turnover efficiency", "2. Adjust equity and transaction structure", "3. Reasonable and legal tax saving", "4. Effectively control costs and increase profits",],
                    head3: ["1. Reasonably standardize the equity structure and avoid risks", "2. Design incentive and partner mechanism", "3. Realize shareholder benefit sharing and risk sharing", "4. Accelerate the company's growth and support the listing plan",],
                    head4: 'Help solve investment and financing difficulties',
                },
                {
                    head1: 'Newest courses',
                    head2: ['《Winning in finance 》', '《Winning in taxation》'],
                    head3: ['《Winning in equity incentives》', '《Winning in equity systems》', '《Winning in equity models》'],
                    head4: '《Winning in capital》',
                },
                {
                    head1: 'Study system',
                    head2: '2–3 days (depending on the specific course)',
                    head3: 'Three days, two evenings',
                    head4: '2–3 days (depending on the specific course)',
                },
                {
                    head1: 'Proposed number of attendees',
                    head2: 'At least two',
                    head3: 'At least two',
                    head4: 'At least two',
                },
                {
                    head1: 'Region',
                    head2: 'Nationwide',
                    head3: 'Nationwide',
                    head4: 'Nationwide',
                },
                {
                    head1: 'Fee',
                    head2: 'Different fees for each specific course. See leaflet for details.',
                    head3: 'Different fees for each specific course. See leaflet for details.',
                    head4: 'Different fees for each specific course. See leaflet for details.',
                },
                {
                    head1: 'Download leaflet',
                    head2: 'Tap to Download',
                    head3: 'Tap to Download',
                    head4: 'Tap to Download',
                },
            ]
        },
        table4: {
            header0: {
                head1: 'Program categories',
                head2: 'Model breakthroughs',
            },
            header: {
                head1: 'Modules',
                head2: 'Business model',
                head3: 'Strategy',
            },
            data: [
                {
                    head1: '',
                    head2: ['Online: Business Model Bootcamp', 'More offline courses Stay tuned'],
                    head3: 'More offline courses Stay tuned',
                },
            ]
        },
    },

}


// WEBPACK FOOTER //
// ./src/lang/class/en.js